// extracted by mini-css-extract-plugin
export default {"servicesSection":"Services_servicesSection__XzHBH","title":"Services_title__wDa67","subtitle":"Services_subtitle__QB6tO"};